<template>
  <v-container class="grey-lighten-3 full-height">
    <v-row justify="center">
      <v-col cols="12" xl="10">
        <v-sheet class="report-paper pa-6" elevation="3" id="printable-area">

          <div class="watermark">
            <img v-if="order?.branch?.company?.logo" :src="getFileServerUrl + order?.branch?.company?.logo" alt="">
          </div>

          <div class="invoice-container">
            <div class="invoice-content">
              <table style="width: 100%; border-collapse: collapse;">
                <thead>
                  <tr v-if="order?.branch?.company?.header_image">
                    <td colspan="100%">
                      <img :src="`${getFileServerUrl}${order?.branch?.company?.header_image}`" style="width: 100%;" alt="">
                    </td>
                  </tr>
                </thead>
                
                <tbody>
                  <!-- Header Section -->
                  <tr v-if="!order?.branch?.company?.header_image">
                    <td colspan="100%">
                      <div class="page-header">
                        <div class="header-section d-flex justify-space-between align-start">
                          <div class="company-info">
                            <h4 class="company-name">{{ order.branch?.company?.name || '' }}</h4>
                            <p class="company-text">{{ order.branch?.company?.address || '' }}</p>
                            <p class="company-text">
                              <v-icon size="small">mdi-phone-outline</v-icon>
                              {{ order.branch?.company?.mobile || '' }}
                            </p>
                            <p class="company-text">
                              <v-icon size="small">mdi-email-outline</v-icon>
                              {{ order.branch?.company?.email || '' }}
                            </p>
                          </div>
                          <div class="logo-container">
                            <v-img
                              :src="`${getFileServerUrl}/${order.branch?.company?.logo || 'uploads/demo_images/user.png'}`"
                              max-width="150"
                              max-height="70"
                              contain
                            />
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="100%">
                      <div class="text-center my-6">
                        <h2 class="report-title">INVOICE BILL</h2>
                      </div>
                    </td>
                  </tr>

                  <!-- Bill To / Ship To Section -->
                  <tr class="master-box-parent">
                    <td colspan="100%">
                      <div class="master-box mt-4" style="font-size: 13px;">
                        <v-row>
                          <v-col cols="6">
                            <div style="height: 110px; border: 1px solid #000; padding: 8px;">
                              <strong>BILL TO:</strong><br/>
                              {{ order.bill_to || '-' }}
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <div style="height: 110px; border: 1px solid #000; padding: 8px;">
                              <strong>SHIP TO:</strong><br/>
                              {{ order.ship_to || '-' }}
                            </div>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="6">
                            <table style="width: 100%; border-collapse: collapse; font-size: 12px;">
                              <tbody>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 4px;"><strong>Invoice Code</strong></td>
                                  <td style="border: 1px solid #000; padding: 4px;">{{ order.code || '-' }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 4px;"><strong>Invoice No</strong></td>
                                  <td style="border: 1px solid #000; padding: 4px;">{{ order.invoice_no || '-' }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 4px;"><strong>Invoice Date</strong></td>
                                  <td style="border: 1px solid #000; padding: 4px;">{{ formatDate(order.invoice_date) }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </v-col>
                          <v-col cols="6">
                            <table style="width: 100%; border-collapse: collapse; font-size: 12px;">
                              <tbody>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 4px;"><strong>Due Date</strong></td>
                                  <td style="border: 1px solid #000; padding: 4px;">{{ formatDate(order.invoice_due_date) }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 4px;"><strong>Status</strong></td>
                                  <td style="border: 1px solid #000; padding: 4px;">{{ order.status ? 'Active' : 'Inactive' }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 4px;"><strong>Total Due</strong></td>
                                  <td style="border: 1px solid #000; padding: 4px;">{{ order.due || '-' }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="6">
                            <div style="height: 130px; border: 1px solid #000; padding: 8px;">
                              <strong>BANK INFORMATION:</strong><br/>
                              <strong>Bank Name:</strong>  {{ order.bank_name || '-' }}<br/>
                              <strong>Account Name:</strong>  {{ order.bank_ac_name || '-' }}<br/>
                              <strong>Account No:</strong>  {{ order.bank_ac_no || '-' }}<br/>
                              <strong>Routing No:</strong>  {{ order.routing_no || '-' }}<br/>
                              <strong>Swift Code:</strong>  {{ order.swift_code || '-' }}
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <div style="height: 130px; border: 1px solid #000; padding: 8px;">
                              <strong>REMARKS:</strong><br/>
                              {{ order.remarks || '-' }}
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </td>
                  </tr>

                  <!-- Details Table -->
                  <tr>
                    <td colspan="100%" style="border: none;">
                      <table class="dep-table order-table mt-4" style="width: 100%; border-collapse: collapse;">
                        <thead>
                          <tr>
                            <th style="border: 1px solid #000; padding: 8px;">SL</th>
                            <th style="border: 1px solid #000; padding: 8px;">Description</th>
                            <th class="text-right" style="border: 1px solid #000; padding: 8px;">Price</th>
                            <th class="text-right" style="border: 1px solid #000; padding: 8px;">Qty</th>
                            <th class="text-right" style="border: 1px solid #000; padding: 8px;">Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, i) in order.details" :key="row.id">
                            <td class="text-center" style="border: 1px solid #000; padding: 8px;">{{ i + 1 }}</td>
                            <td style="border: 1px solid #000; padding: 8px;">{{ row.item_description }}</td>
                            <td class="text-right" style="border: 1px solid #000; padding: 8px;">{{ row.price }}</td>
                            <td class="text-right" style="border: 1px solid #000; padding: 8px;">{{ row.quantity }}</td>
                            <td class="text-right" style="border: 1px solid #000; padding: 8px;">{{ row.total }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  <!-- Footer Info Section -->
                  <tr>
                    <td colspan="100%" style="border: none;">
                      <v-row class="mt-4">
                        <v-col cols="4" class="text-center">
                          <div class="footer-item" style="display: flex; justify-content: center; align-items: center; gap: 10px; border: 1px solid #000; padding: 12px;">
                            <v-icon>mdi-whatsapp</v-icon>
                            <div>+8801798055022</div>
                          </div>
                        </v-col>

                        <v-col cols="4" class="text-center">
                          <div class="footer-item" style="display: flex; justify-content: center; align-items: center; gap: 10px; border: 1px solid #000; padding: 12px;">
                            <v-icon>mdi-web</v-icon>
                            <div style="font-size: 12px;">
                              info@anooshasourcing.com<br/>
                              www.anooshasourcing.com
                            </div>
                          </div>
                        </v-col>

                        <v-col cols="4" class="text-center">
                          <div class="footer-item" style="display: flex; justify-content: center; align-items: center; gap: 10px; border: 1px solid #000; padding: 12px;">
                            <v-icon>mdi-home</v-icon>
                            <div style="font-size: 12px;">
                              5th Floor, House 417, Road 7<br/>
                              Baridhara DOHS, Dhaka-1206
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </td>
                  </tr>
                </tbody>

                <tfoot>
                  <tr>
                    <td colspan="100%" style="border:none">
                      <div style="width:100%;height: 100px;";>&nbsp;</div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div class="invoice-footer">
              <img v-if="order?.branch?.company?.footer_image" :src="`${getFileServerUrl}${order?.branch?.company?.footer_image}`" alt="Footer Image" style="width: 100%; display: block;">
            </div>
          </div>

        </v-sheet>
      </v-col>
    </v-row>

    <!-- Print Button -->
    <v-row justify="center" class="d-print-none mt-4">
      <v-btn color="primary" prepend-icon="mdi-printer" @click="print">
        Print
      </v-btn>
    </v-row>

  </v-container>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

const store = useStore();
const route = useRoute();

const order = ref({
  branch: {},
  details: []
});

const getFileServerUrl = computed(() => store.getters.getFileServerUrl);

// date format helper
function formatDate(date) {
  if (!date) return "-";
  return new Date(date).toLocaleDateString("en-GB");
}

// fetch invoice bill
async function fetchDetails(id) {
  const res = await store.dispatch("getInvoiceBillById", { id });
  order.value = res.data.data;
}

// print function
function print() {
  const printContent = document.getElementById("printable-area").innerHTML;
  const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}`);

  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Invoice Bill</title>
    <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
    <style>
      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }

      @page {
        size: A4;
        margin: 0;
        padding: 0;
      }

      html, body {
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
      }

      body { 
        font-family:"Times New Roman", serif; 
        background:#fff; 
        color:#000; 
        -webkit-print-color-adjust: exact; 
        print-color-adjust: exact;
      }

      .report-paper { 
        width: 100%; 
        padding: 0;
        background: #fff;
      }

      .watermark {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 0;
      }

      header img {
        width: 100%;
        display: block;
        margin: 0;
        padding: 0;
      }

      main { 
        position: relative;
        padding-top: 180px;
        padding-bottom: 150px;
        padding-left: 20px;
        padding-right: 20px;
        page-break-after: avoid;
      }

      main > * {
        page-break-inside: avoid;
      }

      footer {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        z-index: 10;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      footer img {
        width: 100%;
        display: block;
        margin: 0;
        padding: 0;
      }

      .page-header {
        margin-top:250px;
        margin-bottom: 20px;
      }

      .header-section { 
        display: flex; 
        justify-content: space-between; 
        align-items: flex-start; 
        border-bottom: 2px solid #eee; 
        padding-bottom: 10px; 
        margin-bottom: 16px; 
      }

      .company-name { 
        font-size: 20px; 
        font-weight: bold; 
        text-transform: uppercase; 
        margin: 0 0 4px 0; 
      }

      .company-text { 
        font-size: 14px; 
        margin: 2px 0; 
        display: flex; 
        align-items: center; 
      }

      .logo-container img { 
        max-height: 70px; 
        max-width: 150px; 
      }

      .report-title { 
        font-size: 20px; 
        text-align: center; 
        margin: 16px 0; 
      }

      .master-box {
        margin-top: 16px;
        margin-bottom: 16px;
        font-size: 13px;
      }

      table { 
        width: 100%; 
        border-collapse: collapse; 
        font-size: 13px; 
        margin-bottom: 24px;
        background: white;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      th, td { 
        border: 1px solid #000; 
        padding: 6px; 
        vertical-align: middle; 
      }

      th { 
        background: #e0e0e0; 
        text-align: center; 
        font-weight: bold;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      .master-box-parent {
        border: none;
      }

      .text-center { text-align: center; }
      .text-right { text-align: right; }
      .mt-4 { margin-top: 16px !important; }
      .my-6 { margin-top: 24px !important; margin-bottom: 24px !important; }

      img { 
        max-width: 100% !important; 
        height: auto !important; 
      }

      .d-flex { display: flex; }
      .justify-space-between { justify-content: space-between; }
      .align-start { align-items: flex-start; }
      .v-row { 
        display: flex !important; 
        flex-wrap: wrap !important; 
        margin: 0 -12px;
      }

      .v-col-6 { 
        flex: 0 0 50% !important; 
        max-width: 50% !important; 
        padding: 12px;
        box-sizing: border-box;
      }

      .v-col-4 {
        flex: 0 0 33.3333% !important;
        max-width: 33.3333% !important;
        padding: 12px;
        box-sizing: border-box;
      }

      .v-col-12 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
        padding: 12px;
        box-sizing: border-box;
      }

      .pa-6 { padding: 0 !important; }

      .order-table thead {
        display: table-header-group;
      }

      .order-table tbody tr {
        page-break-inside: avoid;
      }

      @media print { 
        body {
          margin: 0;
          padding: 0;
        }

        .watermark {
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 0;
        }

        .report-paper {
          margin: 0;
          padding: 0;
        }

        main {
          padding-top: 180px;
          padding-bottom: 150px;
          padding-left: 20px;
          padding-right: 20px;
        }

        .invoice-container {
          display: flex;
          flex-direction: column;
        }

        .invoice-content {
          flex: 1;
          overflow: hidden;
        }

        .invoice-footer {
          margin-top: auto;
          position: fixed;
          left: 0;
          bottom: 15px;
          width: 100%;
        }

        .order-table {
          page-break-inside: auto;
        }

        .order-table tr {
          page-break-inside: avoid;
          page-break-after: auto;
        }

        .order-table thead {
          display: table-header-group;
        }
      }
    </style>
    </head>
    <body>
      ${printContent}
    </body>
    </html>
  `);

  printWindow.document.close();
  printWindow.focus();
  setTimeout(() => printWindow.print(), 500);
}

onMounted(() => {
  fetchDetails(route.params.id);
});
</script>

<style scoped>
.full-height { min-height: 60vh; }
.grey-lighten-3 { background-color: #eeeeee !important; }
.report-paper { background: white; }
.company-name { font-size: 20px; font-weight: bold; text-transform: uppercase; }
.company-text { font-size: 14px; }
.report-title { font-size: 20px; text-align: center; margin: 16px 0; }
.meta-box { border: 1px solid #000; padding: 8px; font-size: 13px; margin-bottom: 16px; }
.dep-table { width: 100%; border-collapse: collapse; font-size: 13px; }
.dep-table th, .dep-table td { border: 1px solid #000; padding: 6px; }
.dep-table th { background: #e0e0e0; }
.text-center { text-align: center; }
.text-right { text-align: right; }
.watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
}
.d-print-none {
  display: block !important;
}

.page-header {
  margin-bottom: 20px;
}

.header-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 2px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 16px;
}

.company-info {
  flex: 1;
}

.logo-container {
  flex-shrink: 0;
  margin-left: 20px;
}

.order-table {
  width: 100%;
  border-collapse: collapse;
  margin: 15px 0;
}

.invoice-container {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.invoice-content {
  flex: 1;
}

.invoice-footer {
  margin-top: auto;
}

@media print {
  .d-print-none {
    display: none !important;
  }
}
</style>
